import { createContext, useContext } from "react";

import { ProductDayTripPlanI18nFormModelContext } from "../../_context/context";

import type { ProductDayTripPlanI18nFormModelContextType } from "../../_context/context";

export type ProductExistingDayTripPlanI18nFormModelContextType = {
	onUpdate: () => void;
} & ProductDayTripPlanI18nFormModelContextType;

export const ProductExistingDayTripPlanI18nFormModelContext =
	createContext<ProductExistingDayTripPlanI18nFormModelContextType | null>(null);

export const ProductExistingDayTripPlanI18nFormModelContextProvider = ({
	value,
	children,
}: {
	value: ProductExistingDayTripPlanI18nFormModelContextType;
	children: React.ReactNode;
}) => {
	return (
		<ProductExistingDayTripPlanI18nFormModelContext.Provider value={value}>
			<ProductDayTripPlanI18nFormModelContext.Provider value={value}>
				{children}
			</ProductDayTripPlanI18nFormModelContext.Provider>
		</ProductExistingDayTripPlanI18nFormModelContext.Provider>
	);
};

export const useProductExistingDayTripPlanI18nFormModelContext = () => {
	const context = useContext(ProductExistingDayTripPlanI18nFormModelContext);

	if (!context) {
		throw new Error(
			"useProductExistingDayTripPlanI18nFormModelContext must be used within a ProductExistingDayTripPlanI18nFormModelContextProvider",
		);
	}

	return {
		onUpdate: context.onUpdate,
	};
};
